<template>
  <v-dialog
    v-model="relocation_dialog"
    width="640"
    content-class="card pa-0 confirm-dialog"
  >
    <v-btn
      icon
      dark
      variant="text"
      class="dialog-close-btn"
      @click="$emit('close-dialog')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <div class="banner-confirm-thnx-img">
      <img :src="`${configdata.url.cdn}/activities/${image}`" />
    </div>
    <div class="pa-md-16 pa-8">
      <h3 class="step-title">
        {{
          $i18n.locale == "nl"
            ? "Wijziging is gelukt!"
            : "Change is successful!"
        }}
      </h3>
      <k-spacing y="8"></k-spacing>

      <p
        v-safe-html="
          $i18n.locale == 'nl'
            ? `Jouw aanmelding is succesvol verplaatst  naar  <strong>${toAmsterdamCalendarDate(
                new_date
              )
                .toLocaleDateString('nl-NL', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric',
                })
                .replace(
                  /(\w{3})/,
                  '$1.'
                )}</strong>, <strong>${new_start} - ${new_end}</strong>`
            : ''
        "
      ></p>

      <k-spacing y="8"></k-spacing>

      <v-row>
        <v-col cols="12" class="d-flex">
          <v-btn
            class="btn quickfix-btn text-white"
            :block="is_mobile"
            color="var(--company-primary)"
            @click="$emit('close-dialog')"
          >
            {{ $i18n.locale == "nl" ? "Afsluiten" : "Close" }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
import { useMainStore } from "../stores/store";
import config from "@/config";
import isMobile from "@/mixins/isMobile";
import { toAmsterdamCalendarDate } from "@/util/DateUtil";
export default {
  mixins: [isMobile],
  components: {},
  props: {
    title: String,
    image: String,
    new_start: String,
    new_end: String,
    new_date: String,
    old_start: String,
    old_end: String,
    old_date: String,
  },
  data: () => ({
    config: config,
    mainstore: useMainStore(),
  }),
  watch: {
    relocation_dialog() {
      this.$emit("close-dialog");
    },
  },
  computed: {
    configdata() {
      return config;
    },
  },

  methods: {
    // Uit @/util/DateUtil, zodat de template hem kan aanroepen.
    toAmsterdamCalendarDate,
  },
};
</script>
